export default "__VITE_ASSET__DcjaPWBS__"